import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSubcomment({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M.714 0a.71.71 0 0 1 .715.706v1.882c0 .65.533 1.177 1.19 1.177h2.942L3.924 2.146a.7.7 0 0 1 0-.998.72.72 0 0 1 1.01 0L7.79 3.97a.7.7 0 0 1 0 .999L4.934 7.793a.72.72 0 0 1-1.01 0 .7.7 0 0 1 0-.998L5.56 5.176H2.62C1.173 5.176 0 4.018 0 2.588V.706C0 .316.32 0 .714 0z"/>
        </svg>
    );
}

export default IconSubcomment;
